import {
    FormControl,
    Grid,
    MenuItem,
    Select,
    Typography,
} from '@material-ui/core'
import { DataGrid } from '@mui/x-data-grid'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    GridHeaderEl,
    NoRowsOverlayEl,
    PlaceholderEl,
} from '../../shared/elements'
import { getProviderTimeoffs } from '../../store/actions/provider'
import * as actionTypes from '../../store/actionType'
import LoadingPage from '../../utilities/loading-page'
import RequestTimeoffModal from './RequestTimeoffsModal'
import './styles.scss'

const TimeOffs = (props) => {
    const status = ['Pending', 'Approved', 'Rejected']
    const [selectedOption, setSelectedOption] =
        useState(null)
    const loading = useSelector(
        (state) => state.loader.loading,
    )

    const { userid } = props
    const dispatch = useDispatch()
    const timeoffsList = useSelector(
        (state) => state.provider.timeoffList,
    )

    const [
        isRequestTimeoffsModalOpen,
        setIsRequestTimeoffsModalOpen,
    ] = useState(false)
    const [selectedRow, setSelectedRow] = useState(false)
    const [operation, setOperation] = useState('')

    useEffect(() => {
        dispatch(
            getProviderTimeoffs(userid, selectedOption),
        )
    }, [selectedOption])

    useEffect(() => {
        props.handleSelectedTab(null)
    }, [])

    function onSort(value) {
        dispatch({
            type: actionTypes.TIMEOFFS_SORT_DATA,
            value: value.field,
        })
    }

    const columns = [
        {
            renderHeader: (values) => (
                <GridHeaderEl
                    title="Time-off Duration (Date)"
                    onSort={onSort}
                    {...values}
                />
            ),
            sortable: false,
            field: 'start_date',
            flex: 0.8,
            renderCell: (cellValues) => {
                return (
                    <span>
                        {moment
                            .utc(
                                `${cellValues.row.start_date} ${cellValues.row.start}`,
                            )
                            .local()
                            .format('MM/DD/YYYY')}
                        &nbsp; - &nbsp;
                        {moment
                            .utc(
                                `${cellValues.row.end_date} ${cellValues.row.end}`,
                            )
                            .local()
                            .format('MM/DD/YYYY')}
                    </span>
                )
            },
        },
        {
            renderHeader: (values) => (
                <GridHeaderEl
                    title="Time"
                    field="start"
                    onSort={onSort}
                    {...values}
                />
            ),
            flex: 0.7,
            sortable: false,
            field: 'start',
            renderCell: (cellValues) => {
                return (
                    <span>
                        {moment
                            .utc(
                                `${cellValues.row.start_date} ${cellValues.row.start}`,
                            )
                            .local()
                            .format('hh:mm A')}
                        &nbsp; - &nbsp;
                        {moment
                            .utc(
                                `${cellValues.row.end_date} ${cellValues.row.end}`,
                            )
                            .local()
                            .format('hh:mm A')}
                    </span>
                )
            },
        },
        {
            renderHeader: (values) => (
                <GridHeaderEl
                    title="No. of Appointments"
                    field="appointments"
                    onSort={onSort}
                    {...values}
                />
            ),
            sortable: false,
            field: 'appointments',
            flex: 0.7,
            renderCell: ({ value }) => {
                return value.length
            },
        },
        {
            renderHeader: (values) => (
                <GridHeaderEl
                    title="Status"
                    field="status"
                    onSort={onSort}
                    {...values}
                />
            ),
            sortable: false,
            field: 'status',
            flex: 0.5,
            renderCell: ({ value }) => {
                return value
            },
        },
        {
            headerName: (
                <Typography variant="body2">
                    Actions
                </Typography>
            ),
            field: 'action',
            flex: 1,
            sortable: false,
            renderCell: (cellValues) => (
                <div
                    style={{
                        display: 'flex',
                    }}>
                    <Typography
                        noWrap
                        color="primary"
                        onClick={() => {
                            console.log(
                                moment(
                                    `${cellValues.row.start_date} ${cellValues.row.start}`,
                                ),
                            )
                            props.handleSelectedTab({
                                date: moment(
                                    `${cellValues.row.start_date} ${cellValues.row.start}`,
                                ),
                                tabIndex: 1,
                            })
                        }}
                        style={{
                            cursor: 'pointer',
                            marginRight: '1em',
                        }}>
                        <strong>View Appointments</strong>
                    </Typography>
                    {cellValues.row.status == 'pending' && (
                        <Typography
                            noWrap
                            color="primary"
                            onClick={() => (
                                setIsRequestTimeoffsModalOpen(
                                    true,
                                ),
                                setSelectedRow(
                                    cellValues.row,
                                ),
                                setOperation('approve')
                            )}
                            style={{
                                cursor: 'pointer',
                                marginRight: '1em',
                            }}>
                            <strong>Approve</strong>
                        </Typography>
                    )}
                    {cellValues.row.status == 'pending' && (
                        <Typography
                            noWrap
                            color="primary"
                            onClick={() => (
                                setIsRequestTimeoffsModalOpen(
                                    true,
                                ),
                                setSelectedRow(
                                    cellValues.row,
                                ),
                                setOperation('reject')
                            )}
                            style={{
                                cursor: 'pointer',
                                marginRight: '1em',
                            }}>
                            <strong>Reject</strong>
                        </Typography>
                    )}
                </div>
            ),
        },
    ]

    return (
        <>
            {loading && <LoadingPage />}
            <div className="MuiDataGrid-table-wrapper">
                <Grid
                    container
                    direction="column"
                    spacing={2}
                    alignItems="flex-end">
                    <Grid item xs={12}>
                        <FormControl className="documentheader">
                            <Select
                                id="docdropdown"
                                className="documentSelect"
                                disableUnderline
                                value={selectedOption}
                                displayEmpty
                                renderValue={() =>
                                    selectedOption ? (
                                        selectedOption
                                    ) : (
                                        <PlaceholderEl>
                                            Status
                                        </PlaceholderEl>
                                    )
                                }
                                onChange={(e) =>
                                    setSelectedOption(
                                        e.target.value,
                                    )
                                }>
                                {status.map((option) => (
                                    <MenuItem
                                        value={option}
                                        key={option}
                                        className="pl-select-option">
                                        {option}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid
                        container
                        item
                        className="bg-white">
                        <DataGrid
                            getRowId={(row) => row.id}
                            rows={timeoffsList}
                            columns={columns}
                            rowCount={timeoffsList.length}
                            disableColumnSelector
                            disableSelectionOnClick
                            autoHeight
                            rowHeight={50}
                            pageSize={10}
                            components={{
                                NoRowsOverlay: () => (
                                    <NoRowsOverlayEl title="No Time-Offs Found." />
                                ),
                            }}
                        />
                    </Grid>
                </Grid>
            </div>

            {isRequestTimeoffsModalOpen && (
                <RequestTimeoffModal
                    open={isRequestTimeoffsModalOpen}
                    onClose={() => {
                        setIsRequestTimeoffsModalOpen(false)
                    }}
                    className="calendarModal"
                    selectedRow={selectedRow}
                    operation={operation}
                    userid={userid}
                />
            )}
        </>
    )
}

export default TimeOffs
